import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  push(_data: unknown): void {
    // intentional no-op
  }
}
